import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-violet-600 text-white shadow-sm hover:bg-violet-500",
        secondary:
          "border-transparent bg-violet-100 text-violet-700 hover:bg-violet-200",
        destructive:
          "border-transparent bg-red-100 text-red-700 shadow-sm hover:bg-red-200",
        outline: "border-stone-300 text-stone-600 hover:border-violet-400 hover:text-violet-600",
        success:
          "border-transparent bg-emerald-100 text-emerald-700 shadow-sm",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
